<template>
    <div class="customers-invites-accept-to-join">
        <button
            v-t="'crm.customers.invites.acceptToJoin.trigger'"
            class="button"
            type="button"
            @click="showModal = true"
        />

        <portal to="modals">
            <ConfirmModal
                v-if="showModal"
                name="customers-invites-accept-to-join"
                :title="$t('crm.customers.invites.acceptToJoin.title')"
                @confirmed="confirmed"
                @canceled="showModal = false"
            >
                <template #content>
                    <div class="customers-invites-accept-to-join__content">
                        <p v-text="$t('crm.customers.invites.acceptToJoin.content')" />
                    </div>
                </template>
            </ConfirmModal>
        </portal>
    </div>
</template>

<script>
import { acceptToJoinCustomersInvites } from '../../api/customers';
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';

export default {
    name: 'CustomersInvitesAcceptToJoin',
    components: {
        ConfirmModal,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
        };
    },
    methods: {
        async confirmed() {
            try {
                await acceptToJoinCustomersInvites(this.id);
                this.showModal = false;
                this.$emit('confirmed');
            } catch (err) {
                console.log(err);
            }
        },
    },
};
</script>
